/* ===== Module Route Guard ===== */

import type { ReactNode } from 'react'
import { useNavigate } from 'react-router-dom'
import { LayoutGrid } from 'lucide-react'
import { MODULE_DEFINITIONS, isModuleEnabled, type OrgModuleKey } from '@zetyar/domain'
import { useApp } from '@/presentation/providers/useApp'
import { Card } from '@/presentation/components/ui/Card'
import { Button } from '@/presentation/components/ui/Button'

// Hiding a link in the Sidebar is not access control: a disabled module must not render when its
// URL is opened directly either.
export function RequireModule({ module, children }: { readonly module: OrgModuleKey; readonly children: ReactNode }) {
  const { currentOrganization } = useApp()
  const navigate = useNavigate()

  if (isModuleEnabled(currentOrganization, module)) {
    return <>{children}</>
  }

  const label = MODULE_DEFINITIONS.find((definition) => definition.key === module)?.label ?? 'Este módulo'

  return (
    <Card className="mx-auto mt-10 max-w-lg p-8 text-center">
      <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-[14px] bg-neutral-100 text-neutral-500 dark:bg-neutral-800 dark:text-neutral-400">
        <LayoutGrid className="h-6 w-6" />
      </div>
      <h1 className="text-lg font-bold text-neutral-900 dark:text-neutral-100">Módulo no disponible</h1>
      <p className="mt-2 text-sm text-neutral-500 dark:text-neutral-400">
        {label} no está activo para {currentOrganization?.name ?? 'esta organización'}. Si lo necesitas, pídelo a la
        administración de tu organización: puede activarlo desde Configuración.
      </p>
      <Button className="mt-6" variant="outline" onClick={() => navigate('/dashboard')}>
        Volver al inicio
      </Button>
    </Card>
  )
}
